/** Protocol error codes and their retryable flag. */

export const ERROR_CODES = {
  unauthorized:   { retryable: false },
  // Ключ настоящий и сессия открыта, но роли этот метод не положен. Отдельно
  // от unauthorized: там «представьтесь», здесь «вам сюда нельзя». Путать их
  // значит отправлять агента переподключаться по кругу в надежде, что
  // поможет, — а не поможет никогда.
  forbidden:      { retryable: false },
  bad_frame:      { retryable: false },
  unknown_method: { retryable: false },
  validation:     { retryable: false },
  not_found:      { retryable: false },
  conflict:       { retryable: false },
  rate_limited:   { retryable: true },
  internal:       { retryable: true },
  timeout:        { retryable: true },
  offline:        { retryable: true },
  slow_consumer:  { retryable: false },
} as const;

export type ErrorCode = keyof typeof ERROR_CODES;

export interface ProtocolError {
  code: ErrorCode;
  msg: string;
  retryable: boolean;
}

export function protocolError(code: ErrorCode, msg: string): ProtocolError {
  return { code, msg, retryable: ERROR_CODES[code].retryable };
}

/** Thrown by handlers; the router turns it into a `res ok:false` frame. */
export class RpcError extends Error {
  readonly code: ErrorCode;

  constructor(code: ErrorCode, msg: string) {
    super(msg);
    this.name = 'RpcError';
    this.code = code;
  }

  toProtocol(): ProtocolError {
    return protocolError(this.code, this.message);
  }
}
